import axiosInstance from './Axios';

export interface ProductMaterial {
  material_id: number;
  parent_id?: string;
  description: string;
}
export function getProductMaterial(
  product_id: string,
): Promise<ProductMaterial[]> {
  const params = { product_id };
  return axiosInstance
    .get<ProductMaterial[]>('/product-material', { params })
    .then((response) => response.data);
}

export interface Color {
  id: number;
  color: string;
}
export function getMaterialColor(material_id: string) {
  const params = { material_id };
  return axiosInstance
    .get<Color[]>(`/material/color`, { params })
    .then((response) => response.data);
}

export interface AttributeSetting {
  fitting                   : string[];
  control_style             : string[];
  control_style_non_manual  : string[];
  control_mat               : string[];
  control_side              : string[];
  stack_direction           : string[];
  track_id                  : string;
  roll_style                : string[];
  control_length            : number[];
  plastic_control_length    : number[];
  cassette_type             : string[];
  bottom_wrap               : string[];
  bot_guide                 : string[];
  hood                      : string[];
  wand_control              : string[];
  chain_control             : string[];
  curtain_setting           : string[];
  curtain_fitting           : string[];
  curtain_stack             : string[];
  stack                     : string[];
  fitting_to                : string[];
  wand_control_length       : number[];
  chain_control_length      : number[];
}
export function getAttributeSetting(product_id: string) {
  const params = { product_id };
  return axiosInstance
    .get<AttributeSetting>('/product-attribute-setting', { params })
    .then((response) => response.data);
}

export interface SubMaterial {
  id: number;
  parent_id?: string[];
  description: string;
  price_index?: string;
  picture?: string;
  unit?: string;
  size?: string;
  product_note?: string;
  product_code?: string;
  part_colors?: string;
}

export function getSubMaterial(parent_material_id: string) {
  const params = { material_id: parent_material_id };
  return axiosInstance
    .get<SubMaterial[]>('/material', { params })
    .then((response) => response.data);
}
export function getSubMaterialNoOrder(parent_material_id: string) {
  const params = { material_id: parent_material_id };
  return axiosInstance
    .get<SubMaterial[]>('/material_no_order', { params })
    .then((response) => response.data);
}

export function getSubMaterialWithPicture(parent_material_id: string) {
  const params = { material_id: parent_material_id };
  return axiosInstance
    .get<SubMaterial[]>('/material_with_picture', {params})
    .then((response) => response.data);
}
export function getPartsList() {
  return axiosInstance
    .get<SubMaterial[]>('/parts')
    .then((response) => response.data);
}
export interface ExtraRequirement {
  id: number;
  requirement: string;
  price: number;
  length: number;
  unit_price: number;
  price_index:number;
}
export function getExtraRequirement() {
  return axiosInstance
    .get<ExtraRequirement[]>(`/extra-requirement`)
    .then((response) => response.data);
}

export interface ListProduct {
  product_id: number;
  name: string;
  code: string;
}
export function getListProduct() {
  return axiosInstance
    .get<ListProduct[]>(`/products`)
    .then((response) => response.data);
}
